import { IGradient } from '../Common/Form/Button';
import { ICommunication } from './Store/ContainerReducer';

export interface IAuthCustomStyle {
    background?: string,
    needConversion?: boolean,
    buttonGradient?: IGradient,
    communication: ICommunication,
}

const blankCommunication: ICommunication = {
    titleLogin: '',
    titleBirthData: '',
    titlePersonalData: '',

    buttonLoginText: '',
    buttonPaymentText: '',
    buttonBirthDataText: '',
    buttonPersonalDataText: '',

    placeholderName: '',
    placeholderEmail: '',
    placeholderGender: '',
    placeholderPassword: '',
    placeholderReference: '',
    placeholderBirthTime: '',
    placeholderBirthDate: '',
    placeholderBirthPlace: ''
};

const CUSTOM_STYLES: Record<string, IAuthCustomStyle> = {
    default: {
        needConversion: false,

        communication: {
            ...blankCommunication
        }
    },

    LPBirthChartPayment: {
        needConversion: true,
        background: 'transparent',

        communication: {
            ...blankCommunication,
            buttonPaymentText: 'authFunctional.themes.LPBirthChartPayment.buttonPaymentText',
            buttonBirthDataText: 'authFunctional.themes.LPBirthChartPayment.buttonBirthDataText',
            buttonPersonalDataText: 'authFunctional.themes.LPBirthChartPayment.buttonPersonalDataText'
        }
    },

    HomeInterLP: {
        needConversion: true,
        background: 'transparent',

        communication: {
            ...blankCommunication,
            buttonLoginText: 'authFunctional.themes.HomeInterLP.buttonLoginText',
            buttonBirthDataText: 'authFunctional.themes.HomeInterLP.buttonBirthDataText',
            buttonPersonalDataText: 'authFunctional.themes.HomeInterLP.buttonPersonalDataText'
        }
    },

    SignsCombination: {
        needConversion: true,
        background: 'transparent',

        communication: {
            ...blankCommunication,
            titleLogin: '',
            titleBirthData: '',
            titlePersonalData: '',
            buttonPaymentText: 'authFunctional.themes.SignsCombination.buttonPaymentText',
            buttonPersonalDataText: 'authFunctional.themes.SignsCombination.buttonPersonalDataText'
        }
    },

    OrbiaLP: {
        needConversion: true,

        communication: {
            ...blankCommunication,
            buttonLoginText: 'authFunctional.themes.OrbiaLP.buttonLoginText',
            buttonBirthDataText: 'authFunctional.themes.OrbiaLP.buttonBirthDataText',
            buttonPersonalDataText: 'authFunctional.themes.OrbiaLP.buttonPersonalDataText'
        }
    },

    Home: {
        needConversion: true,

        buttonGradient: {
            colorOne: '#9931b0',
            colorTwo: '#9931b0',
            fontColor: '#ffffff'
        },

        communication: {
            ...blankCommunication,

            titleLogin: 'authFunctional.themes.Home.titleLogin',
            titleBirthData: 'authFunctional.themes.Home.titleBirthData',
            titlePersonalData: 'authFunctional.themes.Home.titlePersonalData',
            buttonBirthDataText: 'authFunctional.themes.Home.buttonBirthDataText',
            buttonPersonalDataText: 'authFunctional.themes.Home.buttonPersonalDataText'
        }
    },

    FamousMap: {
        needConversion: true,
        background: '#782a9e',

        communication: {
            ...blankCommunication,
            titleLogin: 'authFunctional.themes.FamousMap.titleLogin',
            titleBirthData: 'authFunctional.themes.FamousMap.titleBirthData',
            titlePersonalData: 'authFunctional.themes.FamousMap.titlePersonalData',
            buttonLoginText: 'authFunctional.themes.FamousMap.buttonLoginText',
            buttonBirthDataText: 'authFunctional.themes.FamousMap.buttonBirthDataText',
            buttonPersonalDataText: 'authFunctional.themes.FamousMap.buttonPersonalDataText'
        }
    },

    Horoscope: {
        needConversion: true,

        communication: {
            ...blankCommunication,

            buttonBirthDataText: 'authFunctional.themes.Horoscope.buttonBirthDataText'
        }
    }
};

const getCustomStyle = (name: string): IAuthCustomStyle => {
    const customStyle = CUSTOM_STYLES[name];

    return customStyle || CUSTOM_STYLES.default;
};

export default getCustomStyle;
